import firebase from "firebase/app";
import 'firebase/firestore';

export class Impressaoviagem {

    
    constructor(dadosParaImpressao) {
      this.dadosParaImpressao = dadosParaImpressao;
      
      this.datasaida = new Date(this.dadosParaImpressao.props[0].datahorasaida.seconds*1000).toLocaleString("pt-BR");
      this.dataretorno = new Date(this.dadosParaImpressao.props[0].datahoraretorno.seconds*1000).toLocaleString("pt-BR");
      if (this.dadosParaImpressao.props[0].autorizacoes==undefined) {
        this.dadosParaImpressao.props[0].autorizacoes=[]
      }
    }  
  
    async PreparaDocumento() {
      const corpoDocumento = this.CriaCorpoDocumento();
      const documento = this.GerarDocumento();
      return documento;
    }
  
    CriaCorpoDocumento() {
      
     /* const body = this.dadosParaImpressao.map((prod) => {
        return [
          { text: prod.nome, fontSize: 8 },
          { text: prod.qtdEstoque, fontSize: 8 },
          { text: prod.qtdVendido, fontSize: 8 },
        ];
      });*/

      const body = (() => {
        return [{
            
        }];
      })
  
     
  
      let content = [body];
      
      return content;
    }
    
    
 GerarDocumento() {
        
console.log(this.dadosParaImpressao);
       
      const documento = {
        pageSize: 'A4',
        //pageMargins: [14, 53, 14, 48],
        pageOrientation: 'portait',
        info: {
            title: 'Solicitação de Transporte',
          },
        content: [
       

            {
                alignment: 'center',
                columns: [
                    
                    /*{
               /* image: logo,
                width: 50,
                height: 50, 
            },*/
    
                        {text: [
                            {text: 'Ministério da Educação \n' , style: 'header' },
                            {text: 'Universidade Federal de Santa Maria \n',style: 'subheader'},
                            {text: this.dadosParaImpressao.props[0].depsolicitacao[0].nomedepsol ,style: 'subheader'},
                            
                            ]},
                        
                ] 
            },
            {text: '\n\n' },
            
            {
                alignment: 'center',
                columns: [
                
                    
                            {text: this.dadosParaImpressao.props[0].nsolicitacao},
                            {text: this.dadosParaImpressao.props[0].dsolicitacao},
                           
                            
                        
                ] 
            },
            {text: '\n\n' },
            
            'Ao Núcleo de Transporte/CSG/PROINFRA',
            'Assunto: Solicitação de transporte. \n\n',
    
        
            
        
            'Solicito veículo para transportar os servidores/alunos, conforme dados a seguir:\n',
                {text: '1 – DADOS DA VIAGEM', style: 'subheader'},
            {
                    alignment: 'center',
                style: 'tableExample',
                
                
                table: {
                    
                    body: [
                        ['Dia e Hora', 'Saída: ', this.datasaida , 'Retorno: ',this.dataretorno],
                        ['Localidade(s)',{colSpan: 4, rowSpan: 1, text: this.dadosParaImpressao.props[0].localdestino.description},'','',''],
                        ['Objetivo da Viagem', {colSpan: 4, rowSpan: 1, text: this.dadosParaImpressao.props[0].objetivo},'','',''],
                        
                    ]
                }
            },
            
            {text: '2 – ITINERÁRIO COMPLETO DA VIAGEM (preencher todos os campos)', style: 'subheader'},'\n\n',
            {text:  this.datasaida},
            {text:  this.dadosParaImpressao.props[0].localsaida.description},'\n',


            this.dadosParaImpressao.props[0].listaparadasida.map((item)=>{
                return[
                        
                    {text:  'Parada'},
                     {text:item.value.description, }, '\n',
                    
                     
             ];
             
             
            }),
            {text:  this.dataretorno},
            {text:  this.dadosParaImpressao.props[0].localdestino.description},'\n',

            this.dadosParaImpressao.props[0].listaparadasvolta.map((item)=>{
                return[
                        
                    {text:  'Parada'},
                     {text:item.value.description, }, '\n',
                    
                     
             ];
             
             
            }),
           
           
            
            {text: '3 – DADOS DAS DESPESAS', style: 'subheader'},
            {
                    alignment: 'center',
                style: 'tableExample',
                
                
                table: {
                    
                    body: [
                       // ['Despesas da Viagem', 'Ficarão a cargo da: '],
                        ['Responsável pela Diária ',this.dadosParaImpressao.props[0].nomerespdespesas],
                        ['Ramal para Contato',this.dadosParaImpressao.props[0].fonerespdespesas],
                        
                    ]
                }
            },
            'Atenciosamente, ',
            '(Nome e telefone do Solicitante)', '\n\n',
            {text: this.dadosParaImpressao.props[0].nomesolicitante,alignment: 'center'},
            {text: this.dadosParaImpressao.props[0].telefonesolicitante,alignment: 'center'},'\n',
        'De acordo:',
        '(Nome e Siape)', '\n\n',
        this.dadosParaImpressao.props[0].autorizacoes.map((item)=>{
            return[
                       
 
                 {text:item.nomeassina, alignment: 'center'}, 
                 {text:item.siapeassina, alignment: 'center' },'\n',
                 
                 
         
     
             
         ];
         
         
        }),

        {text: 'Passageiro: ', style: 'subheader'},
        {columns:[
            {text:'Nome'},
            {text:'SIAPE/Matrícula'},
            {text:'Telefone'},
        ]},
        this.dadosParaImpressao.props[0].listapassageiros.map((item)=>{
            return[
                {columns:[
                 {text:item.passageiro.nome},
                 {text:item.passageiro.siapemat},
                 {text:item.passageiro.telefone}, '\n',
                ]},   
                
                 
                
                 
         ];
         
         
        }),
            
        
            
            
    
    
    
            
        ],
      
          styles: {
            header: {
                fontSize: 13,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
            fontSize: 11,
        }
  
    };
      return documento;
    }
  }